import classNames from 'classnames';
import dayjs from 'dayjs';
import React from 'react';
import { HasClassName } from '../component-utils';
import DatePicker from './DatePicker';
import TimePicker from './TimePicker';
import './DateTimePicker.scss';

interface Props extends HasClassName {
  value: number
  onChange(value: number): void
  disabled?: boolean
}

export default function DateTimePicker({ className, value, onChange, disabled }: Props) {
  const day = dayjs(value).startOf('d').valueOf()
  const time = dayjs(value).diff(day, 'm')

  return <div className={classNames('DateTimePicker', className)}>
    <DatePicker className='date' disabled={disabled} value={day} onChange={v => onChange(dayjs(v).add(time, 'm').valueOf())} placement='bottom-end' />
    <TimePicker className='time' disabled={disabled} value={time} onChange={v => onChange(dayjs(day).add(v, 'm').valueOf())} />
  </div>
}
